import React, { useId, useState } from "react";
import { cn } from "@/lib/utils";
import { Label } from "./label";

interface FileInputProps {
  id?: string;
  label: React.ReactNode;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  accept?: string;
  description?: string;
  className?: string;
}

const FileInput: React.FC<FileInputProps> = ({
  id,
  label,
  onChange,
  accept,
  description,
  className,
}) => {
  const uniqueId = useId();
  const [fileName, setFileName] = useState<string>("");
  const inputId = id || uniqueId;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (onChange) {
      onChange(e);
    }
    const name = e.target.files?.[0]?.name || "";
    setFileName(name);
  };

  return (
    <div className={cn("space-y-2", className)}>
      <Label
        htmlFor={inputId}
        className="text-sm font-medium text-foreground"
       
      >
        {label}
      </Label>
      {description && <p className="text-xs text-gray-500">{description}</p>}
      <div className="relative !text-sm cursor-pointer">
        <input
          accept={accept}
          className="w-full px-3 py-2 !text-sm break-words whitespace-normal transition-colors border rounded-md cursor-pointer border-input bg-background ring-offset-background file:border-0 file:bg-transparent file:text-xs file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 hover:bg-accent/50"
          id={inputId}
          onChange={handleChange}
          type="file"
        />
      </div>
      {fileName && (
        <p className="mt-1 text-xs break-all text-muted-foreground">
          {fileName}
        </p>
      )}
    </div>
  );
};

export default FileInput;
